<template>
  <div>
    <condition
      v-for="(c, idx) in conditions"
      :key="idx"
      :idx="idx"
      :condition="c"
      v-on:deleteCondition="deleteCondition"
      :automationId="automationId"
      ref="objConditions"
    />
    <!-- Add condition button -->
    <vs-button
      class="centerx mx-auto"
      radius
      color="primary"
      size="small"
      type="border"
      icon="add"
      @click="addCondition"
    ></vs-button>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import Condition from "./Condition.vue";

export default {
  components: { Condition },
  props: ["conditions", "automationId"],
  data() {
    return {
      baseCondition: {
        _type: "HasReadMailCondition",
        and: true,
        mustBe: true,
      },
    };
  },
  methods: {
    deleteCondition(idx) {
      this.conditions.splice(idx, 1);
    },
    addCondition() {
      this.conditions.push(this.baseCondition);
    },
    render() {
      const rendered = [];
      for (let i = 0; i < this.conditions.length; i++) {
        const renderData = this.$refs.objConditions[i].render();
        rendered.push(renderData);
      }
      return rendered;
    },
  },
  computed: {
    ...mapGetters({}),
  },
  async mounted() {},
};
</script>

<style lang="scss">
</style>